import { Grid, Typography } from "@mui/material";
import { withStyles, WithStyles } from "@mui/styles";
import appMainTheme from "assets/appMainTheme";
import { GlobalClassKeys } from "assets/jss/common-styles";
import classNames from "classnames";
import { DashBoxStyles } from "components/Dashboard/DashBoxStyles";
import { DoughnutCenterText } from "components/Dashboard/DashDoughnut";
import * as React from "react";
import { Doughnut } from "react-chartjs-2";
import Session from "services/Session";

export interface DashDoughnutProps {
    key: any,
    value?: number;
    title: React.ReactNode;
    titlePosition?: "top" | "bottom";
    active?: boolean;
    color: "primary" | "secondary" | "error" | "info" | "success" | "warning" | "muted";
    nullText?: string;
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

type Props = DashDoughnutProps & WithStyles<typeof DashBoxStyles>;

const DashDoughnutBox: React.FC<Props> = (props) => {

    const { title, titlePosition, active, color, classes, value, onClick } = props;
    const nullText = props.nullText || "";
    const theme = appMainTheme(Session.appTheme.themeName, Session.uiCulture);

    var cls = classNames({
        [classes.root]: true,
        [classes[color]]: true,
        [classes.active]: active,
        [classes.cursor]: true
    });

    const graphColor = theme.genie.palette[color] || theme.palette[color];
    const v = Math.round(value);

    const chartData = {
            labels: [
                "Conquistado",
                "A conquistar",
            ],
            datasets: [{
                data: [v, 100 - v],
                backgroundColor: [
                    color == "muted" ? graphColor.dark : graphColor.light,
                    theme.palette.grey[300]
                ],
                hoverBackgroundColor: [
                    graphColor.main,
                    theme.palette.grey[500]
                ],
                options: {
                    elements: {
                        center: {
                            text: value == null ? nullText : `${v}%`,
                            color: graphColor,
                            fontStyle: 'Arial',
                            sidePadding: 20
                        }
                    }
                }

            }]
        };


    return (
        <div className={cls} onClick={onClick}>
            <Grid container wrap="nowrap" justifyContent="space-between" alignItems="center" direction="column" spacing={1} >
                {
                    (titlePosition == "top") &&
                    <Grid item xs zeroMinWidth>
                        <Typography noWrap={true} variant="button" component="div" className={GlobalClassKeys.textCenter}>{title}</Typography>
                    </Grid>
                }
                <Grid item xs zeroMinWidth>
                    {
                        v != null &&
                        <Doughnut
                            width={120}
                            data={chartData}
                            options={
                                {
                                    plugins: {
                                        legend: {
                                            display: false
                                        },
                                        tooltip: {
                                            enabled: false
                                        }
                                    }
                                }
                            }
                            plugins={
                                [DoughnutCenterText]
                            }
                        />
                    }
                </Grid>
                {
                    (titlePosition == null || titlePosition == "bottom") &&
                    <Grid item xs zeroMinWidth>
                        <Typography noWrap={true} variant="button">{title}</Typography>
                    </Grid>
                }
            </Grid>
        </div>
    );
};

export default withStyles(DashBoxStyles)(DashDoughnutBox);
